import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-3 flex flex-col gap-y-4" }
const _hoisted_6 = { class: "text-left uppercase" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "text-left uppercase" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "text-left uppercase" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "text-left uppercase" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" add image ")
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "text-left" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "text-left" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Enable notifications", -1)
const _hoisted_19 = { class: "mt-5 sm:mt-6 text-center" }

import { computed, inject, ref, watch } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Switch,
} from "@headlessui/vue";
import DropdownComponent from "../tools/DropdownComponent.vue";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";

// const CheckIcon = require("@heroicons/vue/solid/CheckIcon");

export default /*#__PURE__*/_defineComponent({
  __name: 'EventRewardEdit',
  props: { form: Object, show: Boolean },
  emits: ["submit", "update:show", "update:form", "edited", "closed"],
  setup(__props, { emit }) {

const props = __props


const store = useStore();
const axios = inject("$axios") as AxiosInstance;

const preview = ref(props.form?.imageUrl);
const file = ref();
const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});
const isLoading = ref(false);
const selectedRewardType = ref({ label: "-Select Reward Type-", value: null });

let rewardType = [
  {
    label: "LOYALTY_POINT",
    value: "LOYALTY_POINT",
  },
  {
    label: "ITEM",
    value: "ITEM",
  },
];

const onfileSelected = async () => {
  // const reader = new FileReader();
  const formData = new FormData();
  const files = file.value.files;
  // const selectedFile = file.value.files[0];
  formData.append("file", files[0]);
  formData.append("uploadType", "event_reward");

  try {
    const image = await uploadPic(formData);

    if (image && image.data.imageUrl) {
      preview.value = image.data.imageUrl;
    }
  } catch (error) {
    alert(error);
  }
};

const uploadPic = async (formData: FormData) => {
  // console.log("formData : ", formData);
  return await axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}/upload/api/internal/image`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "x-cm-operator-id": store.state.selectedOperator.operatorId,
        "x-cm-forwarded-for": "fe-opeartor",
      },
    }
  );
};

const onUpdate = async () => {
  isLoading.value = true
  const payload = {
    id: props.form?.id,
    name: props.form?.name,
    description: props.form?.description,
    is_active: props.form?.is_active,
    reward_type: selectedRewardType.value.value,
    amount: props.form?.amount,
    image_url: preview.value || props.form?.image_url,
  };

  await axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/event/api/event-rewards/update`,
    payload,
    {
      headers: {
        "x-cm-operator-id": store.state.selectedOperator.operatorId,
      },
    }
  ).finally(() => (isLoading.value = false));
  emit("edited");
  showSync.value = false;
};

const onRewardTypeSelected = (e: any) => {
  selectedRewardType.value = e;
  return ((props.form as any).reward_type = e.value);
};

const onClose = () => {
  // form.value.imageUrl = "";
  preview.value = "";
  emit("closed");
  showSync.value = false;
};

watch(showSync, (val) => {
  if (val) {
    preview.value = (props.form as any).imageUrl;
    selectedRewardType.value = {
      label: props.form?.reward_type,
      value: props.form?.reward_type,
    };
  }
});
// onMounted(() => {
//   console.log("props : ", props.form);
// });
// watch(images, (val: any) => (form.value.images = val));

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: _unref(showSync),
      static: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _cache[8] || (_cache[8] = ($event: any) => (showSync.value = false)),
          open: _unref(showSync)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.event.editEventReward")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("messages.event.subName")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.form.name) = $event)),
                              class: "rounded w-full",
                              placeholder: _ctx.$t('messages.event.subName')
                            }, null, 8, _hoisted_7), [
                              [_vModelText, __props.form.name]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("messages.event.rewardAmount")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.form.amount) = $event)),
                              pattern: "/d+",
                              min: "0",
                              class: "rounded w-full",
                              placeholder: _ctx.$t('messages.event.rewardAmount')
                            }, null, 8, _hoisted_9), [
                              [_vModelText, __props.form.amount]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("messages.event.description")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.form.description) = $event)),
                              class: "rounded w-full",
                              placeholder: _ctx.$t('messages.event.description')
                            }, null, 8, _hoisted_11), [
                              [_vModelText, __props.form.description]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("messages.event.rewardType")), 1),
                            _createVNode(DropdownComponent, {
                              class: "w-full",
                              options: _unref(rewardType),
                              modelValue: selectedRewardType.value,
                              onOnOptionSelected: onRewardTypeSelected
                            }, null, 8, ["options", "modelValue"])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("input", {
                              type: "file",
                              ref_key: "file",
                              ref: file,
                              class: "hidden",
                              onChange: _cache[3] || (_cache[3] = ($event: any) => (onfileSelected()))
                            }, null, 544),
                            _createElementVNode("button", {
                              class: "p-1 bg-blue-400 text-white rounded",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => ((_ctx.$refs.file as any).click()))
                            }, [
                              (isLoading.value)
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    class: "text-gray-500",
                                    icon: ['fas', 'circle-notch'],
                                    transform: "grow-6",
                                    spin: ""
                                  }))
                                : _createCommentVNode("", true),
                              _hoisted_13
                            ])
                          ]),
                          (preview.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("messages.rewardCategory.previewImage")), 1),
                                _createElementVNode("img", {
                                  src: preview.value,
                                  class: "mx-auto w-52 h-52 object-contain"
                                }, null, 8, _hoisted_16)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_17, [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.event.active")) + " ", 1),
                            _createVNode(_unref(Switch), {
                              modelValue: (__props.form as any).is_active,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (((__props.form as any).is_active) = $event)),
                              class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", (__props.form as any).is_active ? 'bg-blue-400' : 'bg-red-500'])
                            }, {
                              default: _withCtx(() => [
                                _hoisted_18,
                                _createElementVNode("span", {
                                  class: _normalizeClass([(__props.form as any).is_active ? 'translate-x-6' : 'translate-x-1', "inline-block h-4 w-4 transform rounded-full bg-white"])
                                }, null, 2)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "class"])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (onClose())),
                        class: "mt-3 mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.event.close")), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (onUpdate())),
                        class: "mt-3 ml-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-blue-400 text-base font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.event.edit")), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})